module.exports = __webpack_public_path__ + "img/badge_services_bronze.753b2e47.png";